import axios from "axios";

const administracion = {
  state: () => ({
    modulosUsuario: [],
    modulos: [],
    regionales: [],
    centrosFormacion: [],
    areasTematicas: [],
    programasFormacion: [],
    modalidades: [],
    tiposLider: [],
    cargos: [],
    tipoCompetencias: [],
    tipoAcompanante: [],
    estadosCiviles: [],
    discapacidades: [],
    tiposAlimentacion: [],
  }),

  getters: {
    obtenerModulosUsuario(state) {
      return state.modulosUsuario;
    },

    obtenerModulos(state) {
      return state.modulos;
    },

    obtenerAccionesModulo(state) {
      const modulos = state.modulosUsuario
        .map((moduloPadre) => {
          return moduloPadre.hijos.map((modulo) => {
            return modulo;
          });
        })
        .flat();

      return modulos;
    },

    obtenerRegionales(state) {
      return state.regionales;
    },

    obtenerCentrosFormacion: (state) => (id) => {
      return state.centrosFormacion.filter(
        (centroFormacion) => centroFormacion.regional_id == id
      );
    },

    obtenerCentroFormacion: (state) => (id) => {
      return state.centrosFormacion.find(
        (centroFormacion) => centroFormacion.id == id
      );
    },

    obtenerCentrosFormacionTablero(state) {
      return state.centrosFormacion;
    },

    obtenerCentrosFormacionReporte: (state) => (regionalId) => {
      if (!regionalId) {
        return state.centrosFormacion;
      }
        return state.centrosFormacion.filter(c => c.regional_id == regionalId);
    },

    obtenerAreasTematicas(state) {
      return state.areasTematicas;
    },

    obtenerAreaTematica: (state) => (id) => {
      return state.areasTematicas.find((areaTematica) => areaTematica.id == id);
    },

    obtenerProgramasFormacion: (state) => {
      return state.programasFormacion;
    },

    obtenerModalidades(state) {
      return state.modalidades;
    },

    obtenerTiposLiderCompetencia: (state) => (id) => {
      return state.tiposLider.filter((tipoLider) => tipoLider.id < id);
    },

    obtenerTiposLiderCategoria(state) {
      return state.tiposLider.filter((tipoLider) => tipoLider.id < 10);
    },

    obtenerTiposLiderCampesena: (state) => (id) => {
      return state.tiposLider.filter((tipoLider) => tipoLider.id == id);
    },

    obtenerIdentificaciones(state) {
      const identificaciones = [];
      for (let i = 0; i < state.personas.length; i++) {
        identificaciones.push(state.personas[i].identificacion);
      }
      return identificaciones;
    },

    obtenerCargos(state) {
      return state.cargos;
    },

    obtenerTipoLider(state) {
      return state.tiposLider;
    },

    obtenerTipoCompetencias(state) {
      return state.tipoCompetencias;
    },

    obtenerTipoAcompanante(state) {
      return state.tipoAcompanante;
    },
    obtenerEstadosCiviles(state) {
      return state.estadosCiviles;
    },
    obtenerDiscapacidades(state) {
      return state.discapacidades;
    },
    obtenerTipoAlimentacion(state) {
      return state.tiposAlimentacion;
    },
  },

  mutations: {
    enviarModulosUsuario(state, modulosUsuario) {
      state.modulosUsuario = modulosUsuario;
    },

    enviarModulos(state, modulos) {
      state.modulos = modulos;
    },

    enviarRegionales(state, regionales) {
      state.regionales = regionales;
    },

    enviarCentrosFormacion(state, centrosFormacion) {
      state.centrosFormacion = centrosFormacion;
    },

    enviarAreasTematicas(state, areasTematicas) {
      state.areasTematicas = areasTematicas;
    },

    enviarProgramasFormacion(state, programasFormacion) {
      state.programasFormacion = programasFormacion;
    },

    enviarModalidades(state, modalidades) {
      state.modalidades = modalidades;
    },

    enviarTiposLider(state, tiposLider) {
      state.tiposLider = tiposLider;
    },

    enviarCargos(state, cargos) {
      state.cargos = cargos;
    },

    enviarTipoCompetencias(state, tipoCompetencias) {
      state.tipoCompetencias = tipoCompetencias;
    },

    enviarTipoAcompanante(state, tipoAcompanante) {
      state.tipoAcompanante = tipoAcompanante;
    },
    enviarEstadosCiviles(state, estadosCiviles) {
      state.estadosCiviles = estadosCiviles;
    },
    enviarDiscapacidades(state, discapacidades) {
      state.discapacidades = discapacidades;
    },
    enviarTipoAlimentacion(state, tiposAlimentacion) {
      state.tiposAlimentacion = tiposAlimentacion;
    },
  },

  actions: {
    async crearModulosUsuario(context) {
      try {
        const { data } = await axios.get("api/modulosUsuario");
        context.commit("enviarModulosUsuario", data.results);
      } catch (error) {
        throw new Error("error: ", error);
      }
    },

    crearModulos(context) {
      axios
        .get("api/modulos")
        .then((response) => {
          const modulos = response.data.results;
          context.commit("enviarModulos", modulos);
        })
        .catch(() => {});
    },

    crearRegionales(context) {
      axios
        .get("api/regionales")
        .then((response) => {
          const regionales = [];
          for (let i = 0; i < response.data.results.length; i++) {
            regionales.push({
              id: response.data.results[i].id_regional,
              regional: response.data.results[i].regional,
            });
          }
          context.commit("enviarRegionales", regionales);
        })
        .catch(() => {});
    },

    crearCentrosFormacion(context) {
      axios
        .get("api/centrosFormacion")
        .then((response) => {
          const centrosFormacion = [];
          for (let i = 0; i < response.data.results.length; i++) {
            centrosFormacion.push({
              id: response.data.results[i].id_centro_formacion,
              centro_formacion: response.data.results[i].centro_formacion,
              regional_id: response.data.results[i].regional.id_regional,
              regional: response.data.results[i].regional.regional,
            });
          }
          context.commit("enviarCentrosFormacion", centrosFormacion);
        })
        .catch(() => {});
    },

    crearAreasTematicas(context) {
      axios
        .get("api/areasTematicas")
        .then((response) => {
          const areasTematicas = [];
          for (let i = 0; i < response.data.results.length; i++) {
            areasTematicas.push({
              id: response.data.results[i].id_area_tematica,
              area_tematica: response.data.results[i].area_tematica,
            });
          }

          context.commit("enviarAreasTematicas", areasTematicas);
        })
        .catch(() => {});
    },

    crearProgramasFormacion(context) {
      axios
        .get("api/programasFormacion")
        .then((response) => {
          const programasFormacion = [];
          for (let i = 0; i < response.data.results.length; i++) {
            programasFormacion.push({
              id: response.data.results[i].id_programa_formacion,
              programa_formacion: response.data.results[i].programa_formacion,
              area_tematica_id: response.data.results[i].area_tematica_id,
            });
          }

          context.commit("enviarProgramasFormacion", programasFormacion);
        })
        .catch(() => {});
    },

    crearModalidades(context) {
      axios
        .get("api/modalidades")
        .then((response) => {
          const modalidades = [];
          for (let i = 0; i < response.data.results.length; i++) {
            modalidades.push({
              id: response.data.results[i].id_modalidad,
              modalidad: response.data.results[i].modalidad,
            });
          }

          context.commit("enviarModalidades", modalidades);
        })
        .catch(() => {});
    },

    crearCargos(context) {
      axios.get("api/cargos").then((response) => {
        const cargos = [];
        for (let i = 0; i < response.data.results.length; i++) {
          cargos.push({
            id: response.data.results[i].id_cargo,
            cargo: response.data.results[i].cargo,
          });
        }
        context.commit("enviarCargos", cargos);
      });
    },

    crearTiposLider(context) {
      axios
        .get("api/tiposLider")
        .then((response) => {
          const tiposLider = [];
          for (let i = 0; i < response.data.results.length; i++) {
            tiposLider.push({
              id: response.data.results[i].id_tipo_lider,
              tipo_lider: response.data.results[i].tipo_lider,
            });
          }

          context.commit("enviarTiposLider", tiposLider);
        })
        .catch(() => {});
    },

    crearPersonas(context, identificacion) {
      return new Promise((resolve, reject) => {
        axios
          .get("api/personas/" + identificacion)
          .then((response) => {
            resolve(response.data.results);
          })
          .catch(() => {
            reject();
          });
      });
    },

    crearTiposCompetencia(context) {
      axios
        .get("api/tiposCompetencia")
        .then((response) => {
          const tipoCompetencias = [];
          for (let i = 0; i < response.data.results.length; i++) {
            if (response.data.results[i].id_tipo_competencia != 1) {
              tipoCompetencias.push({
                id: response.data.results[i].id_tipo_competencia,
                tipo_competencia: response.data.results[i].tipo_competencia,
              });
            }
          }

          context.commit("enviarTipoCompetencias", tipoCompetencias);
        })
        .catch(() => {});
    },

    crearTipoAcompanante(context) {
      axios
        .get("api/tipoAcompanante")
        .then((response) => {
          const tipoAcompanante = [];
          for (let i = 0; i < response.data.results.length; i++) {
            tipoAcompanante.push({
              id: response.data.results[i].id_tipo_acompanante,
              tipo_acompanante: response.data.results[i].tipo_acompanante,
            });
          }
          context.commit("enviarTipoAcompanante", tipoAcompanante);
        })
        .catch(() => {});
    },

    crearEstadosCiviles(context) {
      axios
        .get("/api/estadosCivil")
        .then((response) => {
          const estadosCiviles = [];
          for (let i = 0; i < response.data.results.length; i++) {
            estadosCiviles.push({
              id: response.data.results[i].id_estado_civil,
              estado_civil: response.data.results[i].estado_civil,
            });
          }

          context.commit("enviarEstadosCiviles", estadosCiviles);
        })
        .catch(() => {});
    },
    crearDiscapacidades(context) {
      axios
        .get("/api/discapacidades")
        .then((response) => {
          const discapacidades = [];
          for (let i = 0; i < response.data.results.length; i++) {
            discapacidades.push({
              id: response.data.results[i].id_discapacidad,
              discapacidad: response.data.results[i].discapacidad,
            });
          }

          context.commit("enviarDiscapacidades", discapacidades);
        })
        .catch(() => {});
    },
    crearTipoAlimentacion(context) {
      axios
        .get("/api/tiposAlimentacion")
        .then((response) => {
          const tiposAlimentacion = [];
          for (let i = 0; i < response.data.results.length; i++) {
            tiposAlimentacion.push({
              id: response.data.results[i].id_tipo_alimentacion,
              tipo_alimentacion: response.data.results[i].tipo_alimentacion,
            });
          }

          context.commit("enviarTipoAlimentacion", tiposAlimentacion);
        })
        .catch(() => {});
    },
  },
};

export default administracion;
